import ManageCartPage from './ManageCartPage';

export default ManageCartPage;
export { default as reducer } from './cart.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageCartPage/index.ts